<div class="modal-header">
    <h4 class="modal-title">Transaction Details</h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss('Cross click')"><span
            aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body">
    <div class="container">
        <div id="transactionDetailsModalContent" *ngIf="transaction">
            <h5>Transaction ID: {{transaction.trxn?.id}}</h5>
            
            <table class="table">
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Date</p>
                        <p class="m-0 font-weight-bold">{{transaction.trxn?.recDate | date}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Status</p>
                        <p class="m-0 font-weight-bold">{{transactionStatus[transaction.trxn?.status]}}</p>
                    </td>
                </tr>
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Description</p>
                        <p class="m-0 font-weight-bold">{{transaction.trxn?.['cpty']?.name}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Amount</p>
                        <p class="m-0 font-weight-bold">{{accountService.getFormattedAmount(transaction.trxn?.amount)}}</p>
                    </td>
                </tr>
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Payment Amount</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.collDailyAmt ? accountService.getFormattedAmount(transaction.fundingstmt.collDailyAmt) : '-'}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Total Payment Amount</p> 
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.totCollAmt ? accountService.getFormattedAmount(transaction.fundingstmt.totCollAmt) : '-'}}</p>
                    </td>
                </tr>
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Trxn Bal</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.trxnBal ? accountService.getFormattedAmount(transaction.fundingstmt.trxnBal) : '-'}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Current Bal</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.currentBal ? accountService.getFormattedAmount(transaction.fundingstmt.currentBal) : '-'}}</p>
                    </td>
                </tr>
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Bal To Done</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.balToDone ? accountService.getFormattedAmount(transaction.fundingstmt.balToDone) : '-'}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">In Dispute</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.inDispute || '-'}}</p>
                    </td>
                </tr>
                <tr>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;">
                        <p class="m-0 mutedText">Write Off Date</p>
                        <p class="m-0 font-weight-bold">{{transaction.fundingstmt?.writeOffDate ? (transaction.fundingstmt.writeOffDate | date) : '-'}}</p>
                    </td>
                    <td class="border-0" style="min-width:200px !important;padding: 0% !important;"></td>
                </tr>
            </table>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-lg btn-outline-dark w-100"
        (click)="activeModal.close('Close click')">Close</button>
</div>

